(function () {
  'use strict';

  var root = document.querySelector('[data-ymm-gc]');
  if (!root) return;

  var cfg = {};
  try {
    cfg = JSON.parse(root.querySelector('[data-ymm-gc-config]').textContent);
  } catch (e) {
    cfg = {};
  }

  var PLANES = ['front', 'inside', 'back'];
  var TARGET = { w: 1650, h: 2550 };
  var PRINT_IN = 140 / 25.4;
  /* Text size is set against a 440px-wide page, so preview and print keep the same proportions. */
  var TEXT_BASIS = 440;
  var LINE_HEIGHT = 1.15;
  var NAMES = { front: 'Front', inside: 'Inside Left', back: 'Back' };
  var PROPS = { front: 'Front (page 1)', inside: 'Inside Left (page 2)', back: 'Back (page 4)' };
  var SLIDE_FOR_STEP = { 1: 'front', 2: 'front', 3: 'inside', 4: 'inside', 5: 'back', 6: 'back', 7: 'all' };
  var REQUIRED_STEPS = [1, 3, 5];

  var FILESTACK = cfg.filestackApiKey || '';
  var defaults = cfg.placeholders || {};

  var state = {
    files: { front: null, inside: null, back: null },
    texts: {
      'front-1': mkText(10, 7, 80, 36),
      'front-2': mkText(10, 84, 80, 24),
      'inside-1': mkText(10, 8, 80, 36),
      'inside-2': mkText(10, 70, 80, 24),
      'back-1': mkText(10, 10, 80, 36),
      'back-2': mkText(10, 80, 80, 24)
    },
    crop: null,
    adding: false,
    visited: { 1: true },
    attemptedCheckout: false,
    slide: 'product'
  };

  var STORAGE_KEY = 'ymm_gc_constructor_' + (cfg.variantId || 'default');
  var saveTimer = null;
  var restoring = false;

  function mkText(x, y, w, size) {
    return {
      text: '',
      font: 'Jost',
      size: size,
      color: '#0b1426',
      bold: false,
      italic: false,
      underline: false,
      align: 'center',
      x: x,
      y: y,
      w: w
    };
  }

  function $(sel, el) {
    return (el || root).querySelector(sel);
  }

  function $$(sel, el) {
    return Array.prototype.slice.call((el || root).querySelectorAll(sel));
  }

  function money(cents) {
    var n = Math.round(Number(cents) || 0);
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var formatted;
    try {
      formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: code }).format(n / 100);
    } catch (err) {
      formatted = '$' + (n / 100).toFixed(2);
    }
    if (code === 'USD' && formatted.indexOf('USD') === -1) return formatted + ' USD';
    return formatted;
  }

  function qty() {
    var input = $('[data-gc-qty]');
    var n = input ? parseInt(input.value, 10) : 1;
    if (!n || n < 1) n = 1;
    if (n > 99) n = 99;
    if (input) input.value = String(n);
    return n;
  }

  /* ---------- steps + slides ---------- */

  function openStep(num, syncSlide) {
    state.visited[num] = true;
    $$('.ymm-gc-step').forEach(function (step) {
      step.classList.toggle('is-open', Number(step.getAttribute('data-step')) === num);
    });
    if (syncSlide !== false) showSlide(SLIDE_FOR_STEP[num] || 'front');
    updateStepMarks();
    saveState();
  }

  function toggleStep(num) {
    var step = $('.ymm-gc-step[data-step="' + num + '"]');
    if (!step) return;
    if (step.classList.contains('is-open')) {
      state.visited[num] = true;
      step.classList.remove('is-open');
      updateStepMarks();
      saveState();
      return;
    }
    openStep(num);
  }

  function revealImages(root) {
    if (!root) return;
    root.querySelectorAll('img').forEach(function (img) {
      var src = img.getAttribute('src');
      if (!src) return;
      img.loading = 'eager';
      img.decoding = 'auto';
      if (img.complete && img.naturalWidth > 0) return;
      img.src = src;
    });
  }

  function showSlide(name) {
    state.slide = name;
    $$('.ymm-gc-preview__slide').forEach(function (s) {
      var on = s.getAttribute('data-slide') === name;
      s.classList.toggle('ymm-gc-preview__slide--active', on);
      if (on) revealImages(s);
    });
    $$('.ymm-gc-preview__thumb').forEach(function (t) {
      var on = t.getAttribute('data-target') === name;
      t.classList.toggle('ymm-gc-preview__thumb--active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  /* ---------- session restore ---------- */

  function fileSnap(rec) {
    if (!rec) return null;
    var url = rec.fileUrl && rec.fileUrl.indexOf('blob:') !== 0 && rec.fileUrl.indexOf('data:') !== 0
      ? rec.fileUrl
      : '';
    return {
      name: rec.name || 'upload.jpg',
      origW: rec.origW || 0,
      origH: rec.origH || 0,
      fileUrl: url,
      preview: url || rec.preview || ''
    };
  }

  function snapshot(withPreviews) {
    var addons = [];
    $$('.ymm-gc-addon input:checked').forEach(function (cb) {
      addons.push(cb.getAttribute('data-variant-id'));
    });
    var order = orderInput();
    var files = {};
    PLANES.forEach(function (plane) {
      var snap = fileSnap(state.files[plane]);
      if (snap && !withPreviews && !snap.fileUrl) snap = null;
      files[plane] = snap;
    });
    return {
      v: 1,
      files: files,
      texts: state.texts,
      qty: qty(),
      addons: addons,
      visited: state.visited,
      attemptedCheckout: state.attemptedCheckout,
      orderNumber: order ? order.value : '',
      slide: state.slide
    };
  }

  function saveState() {
    if (restoring) return;
    if (saveTimer) clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot(true)));
      } catch (err) {
        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot(false)));
        } catch (ignored) {}
      }
    }, 300);
  }

  function showFileRow(plane, src) {
    var fileRow = $('.ymm-gc-file[data-plane="' + plane + '"]');
    var uploader = $('.ymm-gc-upload[data-plane="' + plane + '"]');
    if (fileRow) {
      fileRow.classList.add('is-on');
      var thumb = fileRow.querySelector('img');
      if (thumb && src) thumb.src = src;
    }
    if (uploader) uploader.style.display = 'none';
  }

  function hideFileRow(plane) {
    var fileRow = $('.ymm-gc-file[data-plane="' + plane + '"]');
    var uploader = $('.ymm-gc-upload[data-plane="' + plane + '"]');
    if (fileRow) fileRow.classList.remove('is-on');
    if (uploader) uploader.style.display = '';
  }

  function applySavedFile(plane, rec) {
    if (!rec || !(rec.fileUrl || rec.preview)) return;
    var src = rec.fileUrl || rec.preview;
    state.files[plane] = {
      name: rec.name || 'upload.jpg',
      origW: rec.origW || 0,
      origH: rec.origH || 0,
      preview: rec.preview || rec.fileUrl,
      blob: null,
      fileUrl: rec.fileUrl || ''
    };
    setPlaneImage(plane, src);
    showFileRow(plane, src);
    if (rec.origW && rec.origH) setQc(plane, rec.origW, rec.origH);
  }

  function textBoxFor(key) {
    var parts = key.split('-');
    return $('.ymm-gc-textpanel[data-plane="' + parts[0] + '"] [data-box="' + parts[1] + '"]');
  }

  function paintFormat(box, data) {
    $$('[data-style]', box).forEach(function (btn) {
      btn.setAttribute('aria-pressed', data[btn.getAttribute('data-style')] ? 'true' : 'false');
    });
    $$('[data-align]', box).forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-align') === data.align ? 'true' : 'false');
    });
  }

  function restoreTexts(texts) {
    Object.keys(state.texts).forEach(function (key) {
      if (!texts[key]) return;
      var data = Object.assign(state.texts[key], texts[key]);
      var box = textBoxFor(key);
      if (box) {
        var ta = box.querySelector('textarea');
        var font = box.querySelector('[data-font]');
        var size = box.querySelector('[data-size]');
        var hidden = box.querySelector('[data-color]');
        var hex = box.querySelector('[data-hex]');
        if (ta) ta.value = data.text || '';
        if (font) {
          font.value = data.font || 'Jost';
          paintFontSelect(font);
        }
        if (size) size.value = String(data.size || 28);
        if (hidden) hidden.value = data.color || '#0b1426';
        if (hex) {
          hex.value = hidden.value;
          hex.dispatchEvent(new Event('change', { bubbles: true }));
        }
        paintFormat(box, data);
      }
      syncText(key);
    });
  }

  function restoreState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var snap = JSON.parse(raw);
      if (!snap || snap.v !== 1) return false;
      restoring = true;
      if (snap.files) {
        PLANES.forEach(function (plane) {
          applySavedFile(plane, snap.files[plane]);
        });
      }
      if (snap.texts) restoreTexts(snap.texts);
      if (snap.qty) {
        var input = $('[data-gc-qty]');
        if (input) input.value = String(snap.qty);
      }
      if (snap.addons && snap.addons.length) {
        snap.addons.forEach(function (id) {
          var cb = $('.ymm-gc-addon input[data-variant-id="' + id + '"]');
          if (cb) cb.checked = true;
        });
      }
      if (snap.visited) state.visited = Object.assign(state.visited, snap.visited);
      if (snap.attemptedCheckout) state.attemptedCheckout = true;
      var order = orderInput();
      if (order && snap.orderNumber) {
        order.value = String(snap.orderNumber).replace(/\D/g, '').slice(0, 10);
        syncOrderError(false);
      }
      restoring = false;
      return snap;
    } catch (err) {
      restoring = false;
      return false;
    }
  }

  /* ---------- images ---------- */

  function qcPass(w, h) {
    return w >= TARGET.w && h >= TARGET.h;
  }

  function setQc(plane, w, h) {
    var el = $('.ymm-gc-qc[data-plane="' + plane + '"]');
    if (!el) return;
    var ok = qcPass(w, h);
    var dpi = Math.max(1, Math.round(w / PRINT_IN));
    el.className = 'ymm-gc-qc ' + (ok ? 'ymm-gc-qc--ok' : 'ymm-gc-qc--bad');
    el.textContent = ok ? 'Print ready (' + dpi + ' DPI)' : 'Low quality Print (' + dpi + ' DPI)';
  }

  function setPlaneImage(plane, url) {
    if (!url) return;
    $$('[data-plane-img="' + plane + '"], [data-all="' + plane + '"]').forEach(function (img) {
      img.src = url;
    });
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      if (/^https?:/i.test(src)) img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function uploadFilestack(blob, name) {
    if (!FILESTACK || !blob) return Promise.resolve('');
    return fetch('https://www.filestackapi.com/api/store/S3?key=' + FILESTACK + '&filename=' + encodeURIComponent(name || 'upload.jpg'), {
      method: 'POST',
      headers: { 'Content-Type': blob.type || 'image/jpeg' },
      body: blob
    }).then(function (res) {
      if (!res.ok) throw new Error('Filestack ' + res.status);
      return res.json();
    }).then(function (data) {
      var url = data.url || '';
      return url ? url + (url.indexOf('?') === -1 ? '?dl=true' : '') : '';
    });
  }

  /* ---------- crop ---------- */

  var cropStage = $('.ymm-gc-crop__stage');
  var cropZoom = $('[data-crop-zoom]');

  function openCrop(file, plane) {
    var modal = $('.ymm-gc-crop');
    var imgEl = $('.ymm-gc-crop__stage img');
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      imgEl.src = url;
      modal.classList.add('is-on');
      requestAnimationFrame(function () {
        var sw = cropStage.clientWidth || 1;
        var sh = cropStage.clientHeight || 1;
        var cover = Math.max(sw / img.width, sh / img.height);
        state.crop = {
          plane: plane,
          file: file,
          img: img,
          objectUrl: url,
          cover: cover,
          scale: cover,
          x: 0,
          y: 0,
          dragging: false,
          lx: 0,
          ly: 0
        };
        if (cropZoom) cropZoom.value = '100';
        paintCrop();
      });
    };
    img.src = url;
  }

  function clampCrop() {
    var c = state.crop;
    var sw = cropStage.clientWidth || 1;
    var sh = cropStage.clientHeight || 1;
    c.scale = Math.max(c.cover, Math.min(c.cover * 4, c.scale));
    var maxX = Math.max(0, (c.img.width * c.scale - sw) / 2);
    var maxY = Math.max(0, (c.img.height * c.scale - sh) / 2);
    c.x = Math.max(-maxX, Math.min(maxX, c.x));
    c.y = Math.max(-maxY, Math.min(maxY, c.y));
  }

  function paintCrop() {
    var c = state.crop;
    if (!c) return;
    clampCrop();
    var imgEl = $('.ymm-gc-crop__stage img');
    imgEl.style.width = c.img.width * c.scale + 'px';
    imgEl.style.height = c.img.height * c.scale + 'px';
    imgEl.style.transform = 'translate(calc(-50% + ' + c.x + 'px), calc(-50% + ' + c.y + 'px))';
    if (cropZoom) cropZoom.value = String(Math.round((c.scale / c.cover) * 100));
  }

  function exportCrop() {
    var c = state.crop;
    var canvas = document.createElement('canvas');
    canvas.width = TARGET.w;
    canvas.height = TARGET.h;
    var ctx = canvas.getContext('2d');
    var scale = TARGET.w / cropStage.clientWidth;
    var dw = c.img.width * c.scale * scale;
    var dh = c.img.height * c.scale * scale;
    var dx = TARGET.w / 2 + c.x * scale - dw / 2;
    var dy = TARGET.h / 2 + c.y * scale - dh / 2;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, TARGET.w, TARGET.h);
    ctx.drawImage(c.img, dx, dy, dw, dh);
    return new Promise(function (resolve) {
      canvas.toBlob(function (blob) {
        resolve({ blob: blob, dataUrl: canvas.toDataURL('image/jpeg', 0.9) });
      }, 'image/jpeg', 0.92);
    });
  }

  function closeCrop() {
    $('.ymm-gc-crop').classList.remove('is-on');
    if (state.crop && state.crop.objectUrl) URL.revokeObjectURL(state.crop.objectUrl);
    state.crop = null;
  }

  function applyUpload(plane, payload, origW, origH, name) {
    state.files[plane] = {
      name: name,
      origW: origW,
      origH: origH,
      preview: payload.dataUrl,
      blob: payload.blob,
      fileUrl: ''
    };
    setPlaneImage(plane, payload.dataUrl);
    showFileRow(plane, payload.dataUrl);
    setQc(plane, origW, origH);
    showSlide(plane);
    refreshCheckoutButtons();
    saveState();
    var rec = state.files[plane];
    uploadFilestack(payload.blob, 'ymm-gc-' + plane + '-image.jpg').then(function (url) {
      if (url && state.files[plane] === rec) {
        rec.fileUrl = url;
        saveState();
      }
    }).catch(function () {});
  }

  function removeUpload(plane) {
    state.files[plane] = null;
    setPlaneImage(plane, defaults[plane]);
    hideFileRow(plane);
    var qc = $('.ymm-gc-qc[data-plane="' + plane + '"]');
    if (qc) {
      qc.className = 'ymm-gc-qc';
      qc.textContent = '';
    }
    showSlide(plane);
    refreshCheckoutButtons();
    saveState();
  }

  /* ---------- texts ---------- */

  var FONT_FALLBACK = {
    'Playfair Display': 'serif',
    Merriweather: 'serif',
    Cinzel: 'serif',
    'Abril Fatface': 'serif',
    Georgia: 'serif',
    'Courier New': 'monospace',
    'Dancing Script': 'cursive',
    'Great Vibes': 'cursive',
    Pacifico: 'cursive',
    Satisfy: 'cursive',
    Caveat: 'cursive',
    Lobster: 'cursive',
    'Permanent Marker': 'cursive'
  };

  function fontStack(name) {
    return '"' + (name || 'Jost') + '", ' + (FONT_FALLBACK[name] || 'sans-serif');
  }

  function loadFace(name, text) {
    if (!document.fonts || !document.fonts.load) return;
    var stack = fontStack(name);
    ['400 32px ', '700 32px ', 'italic 400 32px ', 'italic 700 32px '].forEach(function (spec) {
      document.fonts.load(spec + stack, text || 'Abc').catch(function () {});
    });
  }

  function paintFontSelect(select) {
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var name = opt ? opt.value : 'Jost';
    var stack = fontStack(name);
    select.style.setProperty('font-family', stack, 'important');
    var btn = select.parentNode && select.parentNode.querySelector('[data-font-btn]');
    if (btn) {
      btn.textContent = opt ? opt.textContent : name;
      btn.style.setProperty('font-family', stack, 'important');
    }
    var list = select.parentNode && select.parentNode.querySelector('.ymm-gc-fontpick__list');
    if (list) {
      Array.prototype.forEach.call(list.children, function (item) {
        item.classList.toggle('is-on', item.getAttribute('data-value') === name);
      });
    }
  }

  function closeFontLists() {
    $$('.ymm-gc-fontpick__list').forEach(function (el) { el.hidden = true; });
    $$('[data-font-btn]').forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
  }

  function mountFontPicks() {
    $$('[data-font]').forEach(function (select) {
      if (select.getAttribute('data-font-pick')) return;
      select.setAttribute('data-font-pick', '1');
      Array.prototype.forEach.call(select.options, function (opt) {
        opt.style.setProperty('font-family', fontStack(opt.value), 'important');
        loadFace(opt.value, opt.textContent);
      });
      var wrap = document.createElement('div');
      wrap.className = 'ymm-gc-fontpick';
      select.parentNode.insertBefore(wrap, select);
      wrap.appendChild(select);
      select.classList.add('ymm-gc-fontpick__native');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ymm-gc-fontpick__btn';
      btn.setAttribute('data-font-btn', '');
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Font');
      var list = document.createElement('div');
      list.className = 'ymm-gc-fontpick__list';
      list.hidden = true;
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', 'Fonts');
      Array.prototype.forEach.call(select.options, function (opt) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'ymm-gc-fontpick__opt';
        item.setAttribute('role', 'option');
        item.setAttribute('data-value', opt.value);
        item.textContent = opt.textContent;
        item.style.setProperty('font-family', fontStack(opt.value), 'important');
        item.addEventListener('click', function () {
          select.value = opt.value;
          paintFontSelect(select);
          select.dispatchEvent(new Event('change', { bubbles: true }));
          closeFontLists();
        });
        list.appendChild(item);
      });
      btn.addEventListener('click', function () {
        var willOpen = list.hidden;
        closeFontLists();
        if (willOpen) {
          list.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          var current = list.querySelector('.is-on');
          if (current && current.scrollIntoView) current.scrollIntoView({ block: 'nearest' });
        }
      });
      wrap.addEventListener('click', function (e) { e.stopPropagation(); });
      wrap.appendChild(btn);
      wrap.appendChild(list);
      select.addEventListener('change', function () { paintFontSelect(select); });
      paintFontSelect(select);
    });
    document.addEventListener('click', closeFontLists);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeFontLists();
    });
  }

  function syncText(key) {
    var data = state.texts[key];
    if (!data) return;
    var stack = fontStack(data.font);
    var box = textBoxFor(key);
    if (box) {
      var ta = box.querySelector('textarea');
      if (ta) ta.style.setProperty('font-family', stack, 'important');
    }
    loadFace(data.font, data.text);
    $$('.ymm-gc-text[data-text="' + key + '"]').forEach(function (overlay) {
      if (!data.text) {
        overlay.hidden = true;
        overlay.textContent = '';
        return;
      }
      overlay.hidden = false;
      overlay.textContent = data.text;
      overlay.style.left = data.x + '%';
      overlay.style.top = data.y + '%';
      overlay.style.width = data.w + '%';
      overlay.style.color = data.color;
      overlay.style.setProperty('font-family', stack, 'important');
      overlay.style.fontWeight = data.bold ? '700' : '400';
      overlay.style.fontStyle = data.italic ? 'italic' : 'normal';
      overlay.style.textDecoration = data.underline ? 'underline' : 'none';
      overlay.style.textAlign = data.align || 'center';
      overlay.style.setProperty('--ymm-text-size', String(data.size || 28));
    });
  }

  function hasText(plane) {
    return [1, 2].some(function (n) {
      var t = state.texts[plane + '-' + n];
      return t && String(t.text || '').trim();
    });
  }

  function clampHex(hex) {
    var v = String(hex || '').trim();
    if (v.charAt(0) !== '#') v = '#' + v;
    if (/^#[0-9a-fA-F]{3}$/.test(v)) {
      v = '#' + v.charAt(1) + v.charAt(1) + v.charAt(2) + v.charAt(2) + v.charAt(3) + v.charAt(3);
    }
    return /^#[0-9a-fA-F]{6}$/.test(v) ? v.toLowerCase() : '#0b1426';
  }

  function hexToHsv(hex) {
    var h = clampHex(hex);
    var r = parseInt(h.slice(1, 3), 16) / 255;
    var g = parseInt(h.slice(3, 5), 16) / 255;
    var b = parseInt(h.slice(5, 7), 16) / 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var d = max - min;
    var hue = 0;
    if (d) {
      if (max === r) hue = ((g - b) / d) % 6;
      else if (max === g) hue = (b - r) / d + 2;
      else hue = (r - g) / d + 4;
      hue /= 6;
      if (hue < 0) hue += 1;
    }
    return { h: hue, s: max === 0 ? 0 : d / max, v: max };
  }

  function hsvToHex(h, s, v) {
    var i = Math.floor(h * 6);
    var f = h * 6 - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var r;
    var g;
    var b;
    switch (i % 6) {
      case 0: r = v; g = t; b = p; break;
      case 1: r = q; g = v; b = p; break;
      case 2: r = p; g = v; b = t; break;
      case 3: r = p; g = q; b = v; break;
      case 4: r = t; g = p; b = v; break;
      default: r = v; g = p; b = q;
    }
    function to(n) {
      var x = Math.round(n * 255).toString(16);
      return x.length === 1 ? '0' + x : x;
    }
    return '#' + to(r) + to(g) + to(b);
  }

  function bindDrag(el, onMove) {
    function point(e) {
      var t = e.touches && e.touches[0] ? e.touches[0] : e;
      var r = el.getBoundingClientRect();
      var x = (t.clientX - r.left) / r.width;
      var y = (t.clientY - r.top) / r.height;
      onMove(Math.max(0, Math.min(1, x)), Math.max(0, Math.min(1, y)));
    }
    function up() {
      document.removeEventListener('mousemove', point);
      document.removeEventListener('mouseup', up);
      document.removeEventListener('touchmove', point);
      document.removeEventListener('touchend', up);
    }
    el.addEventListener('mousedown', function (e) {
      e.preventDefault();
      point(e);
      document.addEventListener('mousemove', point);
      document.addEventListener('mouseup', up);
    });
    el.addEventListener('touchstart', function (e) {
      e.preventDefault();
      point(e);
      document.addEventListener('touchmove', point, { passive: false });
      document.addEventListener('touchend', up);
    }, { passive: false });
  }

  function mountPicker(wrap) {
    var hidden = wrap.querySelector('[data-color]');
    var sat = wrap.querySelector('[data-sv]');
    var satDot = wrap.querySelector('[data-sv-dot]');
    var hueEl = wrap.querySelector('[data-hue]');
    var hueThumb = wrap.querySelector('[data-hue-thumb]');
    var hexInput = wrap.querySelector('[data-hex]');
    if (!hidden || !sat) return hidden;
    var hsv = hexToHsv(hidden.value);

    function paint() {
      var hex = hsvToHex(hsv.h, hsv.s, hsv.v);
      hidden.value = hex;
      if (hexInput && document.activeElement !== hexInput) hexInput.value = hex;
      wrap.style.setProperty('--ymm-gc-hue', hsvToHex(hsv.h, 1, 1));
      satDot.style.left = (hsv.s * 100) + '%';
      satDot.style.top = ((1 - hsv.v) * 100) + '%';
      hueThumb.style.left = (hsv.h * 100) + '%';
    }

    bindDrag(sat, function (x, y) {
      hsv.s = x;
      hsv.v = 1 - y;
      paint();
      hidden.dispatchEvent(new Event('input', { bubbles: true }));
    });
    bindDrag(hueEl, function (x) {
      hsv.h = x;
      paint();
      hidden.dispatchEvent(new Event('input', { bubbles: true }));
    });
    if (hexInput) {
      hexInput.addEventListener('change', function () {
        hsv = hexToHsv(hexInput.value);
        paint();
        hidden.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }
    paint();
    return hidden;
  }

  function bindTextPanel(plane) {
    [1, 2].forEach(function (n) {
      var key = plane + '-' + n;
      var box = textBoxFor(key);
      if (!box) return;
      var ta = box.querySelector('textarea');
      var font = box.querySelector('[data-font]');
      var size = box.querySelector('[data-size]');
      var picker = box.querySelector('[data-ymm-picker]');
      var color = picker ? mountPicker(picker) : box.querySelector('[data-color]');
      function commit() {
        syncText(key);
        refreshCheckoutButtons();
        saveState();
      }
      function push() {
        var data = state.texts[key];
        data.text = ta.value;
        data.font = font.value;
        data.size = Number(size.value);
        data.color = color.value;
        if (state.slide !== plane) showSlide(plane);
        commit();
      }
      ta.addEventListener('input', push);
      font.addEventListener('change', push);
      size.addEventListener('change', push);
      color.addEventListener('input', push);
      $$('[data-style]', box).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var prop = btn.getAttribute('data-style');
          state.texts[key][prop] = !state.texts[key][prop];
          paintFormat(box, state.texts[key]);
          commit();
        });
      });
      $$('[data-align]', box).forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.texts[key].align = btn.getAttribute('data-align');
          paintFormat(box, state.texts[key]);
          commit();
        });
      });
    });
  }

  function enableDrag() {
    var dragging = null;
    root.addEventListener('pointerdown', function (e) {
      var el = e.target.closest('.ymm-gc-text');
      if (!el || el.hidden || el.classList.contains('ymm-gc-text--all')) return;
      var key = el.getAttribute('data-text');
      var plane = el.closest('.ymm-gc-plane');
      if (!plane || !state.texts[key]) return;
      e.preventDefault();
      dragging = {
        el: el,
        key: key,
        plane: plane,
        ox: e.clientX,
        oy: e.clientY,
        sx: state.texts[key].x,
        sy: state.texts[key].y
      };
      el.classList.add('is-dragging');
      el.setPointerCapture(e.pointerId);
    });
    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var rect = dragging.plane.getBoundingClientRect();
      var rec = state.texts[dragging.key];
      var boxH = (dragging.el.offsetHeight / rect.height) * 100;
      var dx = ((e.clientX - dragging.ox) / rect.width) * 100;
      var dy = ((e.clientY - dragging.oy) / rect.height) * 100;
      rec.x = Math.min(100 - rec.w, Math.max(0, dragging.sx + dx));
      rec.y = Math.min(Math.max(0, 100 - boxH), Math.max(0, dragging.sy + dy));
      syncText(dragging.key);
    });
    function stop() {
      if (!dragging) return;
      dragging.el.classList.remove('is-dragging');
      dragging = null;
      saveState();
    }
    root.addEventListener('pointerup', stop);
    root.addEventListener('pointercancel', stop);
  }

  /* ---------- composite ---------- */

  function fontSpec(t, px) {
    return (t.italic ? 'italic ' : '') + (t.bold ? '700 ' : '400 ') + px + 'px ' + fontStack(t.font);
  }

  function loadFonts(plane) {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    var jobs = [1, 2].map(function (n) {
      var t = state.texts[plane + '-' + n];
      if (!t || !t.text) return Promise.resolve();
      return document.fonts.load(fontSpec(t, 48), t.text).catch(function () {});
    });
    return Promise.all(jobs);
  }

  function wrapLines(ctx, text, maxW) {
    var lines = [];
    String(text).split(/\r?\n/).forEach(function (para) {
      var words = para.split(/\s+/).filter(Boolean);
      if (!words.length) {
        lines.push('');
        return;
      }
      var line = '';
      words.forEach(function (word) {
        var test = line ? line + ' ' + word : word;
        if (line && ctx.measureText(test).width > maxW) {
          lines.push(line);
          line = word;
        } else {
          line = test;
        }
      });
      lines.push(line);
    });
    return lines;
  }

  function drawText(ctx, t) {
    var px = (t.size || 28) * (TARGET.w / TEXT_BASIS);
    var lh = px * LINE_HEIGHT;
    var left = t.x / 100 * TARGET.w;
    var width = t.w / 100 * TARGET.w;
    var top = t.y / 100 * TARGET.h;
    var align = t.align || 'center';
    var anchor = align === 'left' ? left : (align === 'right' ? left + width : left + width / 2);
    ctx.save();
    ctx.font = fontSpec(t, px);
    ctx.fillStyle = t.color;
    ctx.textAlign = align;
    ctx.textBaseline = 'middle';
    wrapLines(ctx, t.text, width).forEach(function (ln, i) {
      var y = top + lh * i + lh / 2;
      ctx.fillText(ln, anchor, y);
      if (t.underline && ln) {
        var w = ctx.measureText(ln).width;
        var x0 = align === 'left' ? anchor : (align === 'right' ? anchor - w : anchor - w / 2);
        ctx.fillRect(x0, y + px * 0.38, w, Math.max(2, px * 0.06));
      }
    });
    ctx.restore();
  }

  function compositePlane(plane) {
    var rec = state.files[plane];
    var src = rec ? rec.preview : defaults[plane];
    if (!src) return Promise.resolve(null);
    return Promise.all([loadImage(src), loadFonts(plane)]).then(function (res) {
      var canvas = document.createElement('canvas');
      canvas.width = TARGET.w;
      canvas.height = TARGET.h;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(res[0], 0, 0, TARGET.w, TARGET.h);
      [1, 2].forEach(function (n) {
        var t = state.texts[plane + '-' + n];
        if (t && t.text) drawText(ctx, t);
      });
      return new Promise(function (resolve) {
        canvas.toBlob(function (blob) { resolve({ blob: blob, plane: plane }); }, 'image/jpeg', 0.92);
      });
    });
  }

  /* ---------- cart ---------- */

  function extrasTotal() {
    var sum = 0;
    $$('.ymm-gc-addon input:checked').forEach(function (cb) {
      sum += Number(cb.getAttribute('data-price') || 0);
    });
    return sum;
  }

  function refreshPrice() {
    var n = qty();
    var unit = Number(cfg.price) || 0;
    var line = unit * n + Math.round(extrasTotal() * 100) * n;
    var lineEl = $('[data-gc-line]');
    var instEl = $('[data-gc-install]');
    if (lineEl) lineEl.textContent = money(line);
    if (instEl) instEl.textContent = money(Math.round(line / 4));
  }

  function addonItems() {
    var n = qty();
    var items = [];
    $$('.ymm-gc-addon input:checked').forEach(function (cb) {
      var id = cb.getAttribute('data-variant-id');
      if (id) items.push({ id: Number(id), quantity: n, properties: { _hidden: 'true' } });
    });
    return items;
  }

  function collectProperties(urls) {
    var props = {};
    PLANES.forEach(function (plane) {
      if (urls[plane]) props[PROPS[plane]] = urls[plane];
    });
    PLANES.forEach(function (plane) {
      [1, 2].forEach(function (n) {
        var t = state.texts[plane + '-' + n];
        if (t && String(t.text || '').trim()) props[NAMES[plane] + ' Text ' + n] = t.text.trim();
      });
    });
    PLANES.forEach(function (plane) {
      var rec = state.files[plane];
      if (rec && rec.fileUrl) props['_' + NAMES[plane] + ' Image'] = rec.fileUrl;
    });
    var order = orderInput();
    if (order && order.value) props['Order Number'] = order.value.trim();
    return props;
  }

  function orderInput() {
    return $('[data-gc-order-input]');
  }

  function orderValid() {
    var order = orderInput();
    if (!order) return !cfg.requireOrderNumber;
    return /^[0-9]{1,10}$/.test(String(order.value || '').trim());
  }

  function syncOrderError(forceShow) {
    var wrap = $('.ymm-gc-order');
    var order = orderInput();
    var err = $('.ymm-gc-order__error');
    var invalid = !!order && !orderValid();
    var show = forceShow === true ? invalid : (forceShow === false ? false : invalid && order.value);
    if (wrap) wrap.classList.toggle('is-invalid', !!show);
    if (err) err.style.display = show ? 'block' : 'none';
    if (order) order.setAttribute('aria-invalid', show ? 'true' : 'false');
    return !invalid;
  }

  function sanitizeOrderInput() {
    var order = orderInput();
    if (!order) return;
    var digits = String(order.value || '').replace(/\D/g, '').slice(0, 10);
    if (order.value !== digits) order.value = digits;
    if (orderValid()) syncOrderError(false);
  }

  function missingRequired() {
    var missing = [];
    PLANES.forEach(function (plane) {
      if (!state.files[plane]) missing.push(NAMES[plane].toLowerCase() + ' image');
    });
    return missing;
  }

  function stepDone(num) {
    if (num === 1) return !!state.files.front;
    if (num === 2) return hasText('front');
    if (num === 3) return !!state.files.inside;
    if (num === 4) return hasText('inside');
    if (num === 5) return !!state.files.back;
    if (num === 6) return hasText('back');
    if (num === 7) return $$('.ymm-gc-addon input:checked').length > 0;
    return false;
  }

  function updateStepMarks() {
    $$('.ymm-gc-step').forEach(function (step) {
      var num = Number(step.getAttribute('data-step'));
      var done = stepDone(num);
      var skipped = REQUIRED_STEPS.indexOf(num) !== -1 && !done && state.attemptedCheckout;
      step.classList.toggle('is-done', done);
      step.classList.toggle('is-missed', skipped);
    });
  }

  function refreshCheckoutButtons() {
    var ready = missingRequired().length === 0;
    [$('.ymm-gc-atc'), $('[data-gc-shoppay]')].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !!state.adding;
      btn.classList.toggle('is-locked', !ready);
    });
    updateStepMarks();
  }

  function showError(msg) {
    var el = $('.ymm-gc-error');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-on', !!msg);
  }

  function addToCart(goCheckout) {
    if (state.adding) return;
    if (!orderValid()) {
      syncOrderError(true);
      showError('Please enter your order number (numbers only, Max. 10 digits).');
      var order = orderInput();
      if (order) {
        if (order.scrollIntoView) order.scrollIntoView({ behavior: 'smooth', block: 'center' });
        order.focus();
      }
      return;
    }
    var missing = missingRequired();
    if (missing.length) {
      state.attemptedCheckout = true;
      showError('Finish the required steps first: ' + missing.join(', ') + '.');
      refreshCheckoutButtons();
      var firstMissed = $('.ymm-gc-step.is-missed');
      if (firstMissed && firstMissed.scrollIntoView) firstMissed.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    showError('');
    state.adding = true;
    var btn = $('.ymm-gc-atc');
    var pay = $('[data-gc-shoppay]');
    var n = qty();
    var atcHtml = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Preparing your card…';
    if (pay) pay.disabled = true;

    Promise.all(PLANES.map(compositePlane)).then(function (parts) {
      return Promise.all(parts.filter(Boolean).map(function (part) {
        return uploadFilestack(part.blob, 'ymm-gc-' + part.plane + '.jpg').then(function (url) {
          return { plane: part.plane, url: url };
        });
      }));
    }).then(function (rows) {
      var urls = {};
      rows.forEach(function (r) { urls[r.plane] = r.url; });
      var items = [{
        id: Number(cfg.variantId),
        quantity: n,
        properties: collectProperties(urls)
      }].concat(addonItems());
      return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not add to cart. Please try again.');
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      var rootUrl = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      window.location.href = rootUrl + (goCheckout ? 'checkout' : 'cart');
    }).catch(function (err) {
      showError(err.message || 'Could not add to cart.');
      state.adding = false;
      btn.innerHTML = atcHtml;
      refreshCheckoutButtons();
    });
  }

  /* ---------- boot ---------- */

  $$('.ymm-gc-step__head').forEach(function (btn) {
    btn.addEventListener('mousedown', function (e) {
      e.preventDefault();
    });
    btn.addEventListener('click', function () {
      /* A tall step above collapses when this one opens, so keep the clicked header where it was on screen. */
      var top = btn.getBoundingClientRect().top;
      toggleStep(Number(btn.parentNode.getAttribute('data-step')));
      var pin = function () {
        var shift = btn.getBoundingClientRect().top - top;
        if (Math.abs(shift) > 1) window.scrollBy(0, shift);
      };
      pin();
      requestAnimationFrame(pin);
      setTimeout(pin, 0);
      setTimeout(pin, 50);
    });
  });

  $$('.ymm-gc-preview__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      showSlide(btn.getAttribute('data-target'));
      saveState();
    });
  });

  $$('.ymm-gc-upload input').forEach(function (input) {
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (!file) return;
      openCrop(file, input.getAttribute('data-plane'));
      input.value = '';
    });
  });

  $$('[data-edit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = $('.ymm-gc-upload[data-plane="' + btn.getAttribute('data-edit') + '"] input');
      if (input) input.click();
    });
  });

  $$('[data-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      removeUpload(btn.getAttribute('data-remove'));
    });
  });

  if (cropStage) {
    cropStage.addEventListener('pointerdown', function (e) {
      if (!state.crop) return;
      state.crop.dragging = true;
      state.crop.lx = e.clientX;
      state.crop.ly = e.clientY;
      cropStage.setPointerCapture(e.pointerId);
    });
    cropStage.addEventListener('pointermove', function (e) {
      if (!state.crop || !state.crop.dragging) return;
      state.crop.x += e.clientX - state.crop.lx;
      state.crop.y += e.clientY - state.crop.ly;
      state.crop.lx = e.clientX;
      state.crop.ly = e.clientY;
      paintCrop();
    });
    cropStage.addEventListener('pointerup', function () {
      if (state.crop) state.crop.dragging = false;
    });
    cropStage.addEventListener('wheel', function (e) {
      if (!state.crop) return;
      e.preventDefault();
      state.crop.scale *= e.deltaY < 0 ? 1.06 : 0.94;
      paintCrop();
    }, { passive: false });
  }
  if (cropZoom) {
    cropZoom.addEventListener('input', function () {
      if (!state.crop) return;
      state.crop.scale = state.crop.cover * Number(cropZoom.value) / 100;
      paintCrop();
    });
  }

  var cropOk = $('[data-crop-ok]');
  var cropNo = $('[data-crop-cancel]');
  if (cropOk) {
    cropOk.addEventListener('click', function () {
      if (!state.crop) return;
      var plane = state.crop.plane;
      var origW = state.crop.img.naturalWidth || state.crop.img.width;
      var origH = state.crop.img.naturalHeight || state.crop.img.height;
      var name = state.crop.file.name;
      exportCrop().then(function (payload) {
        applyUpload(plane, payload, origW, origH, name);
        closeCrop();
      });
    });
  }
  if (cropNo) cropNo.addEventListener('click', closeCrop);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.crop) closeCrop();
  });

  mountFontPicks();
  PLANES.forEach(bindTextPanel);
  enableDrag();
  $$('.ymm-gc-addon input').forEach(function (cb) {
    cb.addEventListener('change', function () {
      refreshPrice();
      updateStepMarks();
      saveState();
    });
  });
  var minus = $('[data-qty-minus]');
  var plus = $('[data-qty-plus]');
  var qtyInput = $('[data-gc-qty]');
  if (minus) minus.addEventListener('click', function () { qtyInput.value = qty() - 1; refreshPrice(); saveState(); });
  if (plus) plus.addEventListener('click', function () { qtyInput.value = qty() + 1; refreshPrice(); saveState(); });
  if (qtyInput) qtyInput.addEventListener('change', function () { refreshPrice(); saveState(); });
  var orderField = orderInput();
  if (orderField) {
    orderField.addEventListener('input', function () {
      sanitizeOrderInput();
      saveState();
    });
    orderField.addEventListener('blur', function () {
      if (orderField.value) syncOrderError(true);
    });
  }
  $('.ymm-gc-atc').addEventListener('click', function () {
    addToCart(false);
  });
  var shopPay = $('[data-gc-shoppay]');
  if (shopPay) shopPay.addEventListener('click', function () {
    addToCart(true);
  });
  var payform = $('.ymm-gc-payform');
  if (payform) payform.addEventListener('submit', function (e) { e.preventDefault(); });

  var restored = restoreState();
  refreshPrice();
  refreshCheckoutButtons();
  openStep(1, false);
  showSlide(restored && restored.slide ? restored.slide : 'product');

  function syncStickyTop() {
    if (window.matchMedia && !window.matchMedia('(min-width: 990px)').matches) {
      root.style.removeProperty('--ymm-gc-sticky-top');
      return;
    }
    var header = document.querySelector('.t4s-section-header') || document.querySelector('header');
    var top = 12;
    if (header) {
      var box = header.getBoundingClientRect();
      top = Math.max(12, Math.round(box.bottom) + 8);
    }
    root.style.setProperty('--ymm-gc-sticky-top', top + 'px');
  }

  syncStickyTop();
  window.addEventListener('scroll', syncStickyTop, { passive: true });
  window.addEventListener('resize', syncStickyTop);
})();
